











































































































































import Vue from 'vue'
import { Table, TableColumn } from 'element-ui'
import './OpsMonitorTranscoding.scss'
import LeftSidebarLayout from '@/components/LeftSidebarLayout'
import { TranscodingStats, TranscodingMachine, TranscodingProcess, SystemStatus, RequiredSrtLinks } from '@/types/ops'
import { KeyDict } from '@/types'

interface ConvertedTranscodingMachine extends TranscodingMachine {
  stats?: {
    status?: string
  }
  expandeddata?: KeyDict<TranscodingProcess>
  expandeddatasrt?: KeyDict<RequiredSrtLinks>
  numsrtlinks?: string
  numtranscodes?: number
  allocated?: string
}

export default Vue.extend({
  name: 'OpsMonitorTranscoding',
  computed: {
    teamCheck (): boolean|null {
      return this.$store.direct.state.user.teamCheck
    },
    currentUserId (): string {
      return this.$store.direct.state.user.id
    },
    userLoggedIn (): boolean {
      return this.$store.direct.state.user.userLoggedIn
    },
    activeTeam (): string {
      return this.$store.direct.state.team.activeTeam
    },
    transcodingStats (): KeyDict<TranscodingStats> {
      return this.$store.direct.state.opsmonitor.transcodingStats
    },
    transcodingMachines (): KeyDict<TranscodingMachine> {
      return this.$store.direct.state.opsmonitor.transcodingMachines
    }
  },
  watch: {
    transcodingMachines: {
      handler () {
        this.updatedConvertedTranscodingMachines()
      },
      deep: true
    },
    transcodingStats: {
      handler () {
        this.updatedConvertedTranscodingMachines()
      },
      deep: true
    }
  },
  created () {
    this.$store.direct.dispatch.opsmonitor.subscribeTranscodingStats()
    this.$store.direct.dispatch.opsmonitor.subscribeTranscodingMachines()
  },
  beforeDestroy () {
    this.$store.direct.dispatch.opsmonitor.unsubscribeTranscodingStats()
    this.$store.direct.dispatch.opsmonitor.unsubscribeTranscodingMachines()
  },
  data: () => ({
    convertedTranscodingMachines: [] as ConvertedTranscodingMachine[],
    expandRowKeys: []
  }),
  methods: {
    getTranscodingmonitorUrl (ip: string): string {
      return `http://${ip}:9782/transcodingmonitor/`
    },
    updatedConvertedTranscodingMachines () {
      const convertedTranscodingMachines: ConvertedTranscodingMachine[] = []
      Object.entries(this.transcodingMachines).forEach(([machineid, transcodingmachine]) => {
        const machine: ConvertedTranscodingMachine = _.cloneDeep(transcodingmachine)
        let transcodingstats = null as null | TranscodingStats
        const tempStats = this.transcodingStats[machineid]
        if (tempStats !== undefined) {
          transcodingstats = tempStats
          let el = {
            status: 'red'
          }
          if (transcodingstats.systemload) {
            el = { ...el, ...transcodingstats.systemload, status: 'green' }
          }
          machine.stats = el
        } else {
          machine.stats = {}
        }

        // lets flatten is a bit into expandeddata to make rendering easier
        let totalAllocated = 0
        let numtranscodes = 0
        let numsrtlinks = 0
        machine.expandeddata = {}
        machine.expandeddatasrt = {}
        if (machine.processes !== undefined) {
          for (const streamid in machine.processes) {
            const stream = machine.processes[streamid]
            if (stream?.required_transcoding_processes !== undefined) {
              for (const processid in stream.required_transcoding_processes) {
                machine.expandeddata[processid] = stream.required_transcoding_processes[processid]
                machine.expandeddata[processid].processid = processid
                machine.expandeddata[processid].streamid = streamid
                machine.expandeddata[processid].type = 'required_transcoding_processes'
                machine.expandeddata[processid].status = SystemStatus.ERROR
                machine.expandeddata[processid].statusclass = 'status redstatus'
                if (transcodingstats?.transcodes?.[processid].status !== undefined) {
                  machine.expandeddata[processid].status = transcodingstats.transcodes[processid].status
                  if (machine.expandeddata[processid].status === SystemStatus.OK) {
                    machine.expandeddata[processid].statusclass = 'status greenstatus'
                  }
                }
                totalAllocated += machine.expandeddata[processid].cpu
                numtranscodes += 1
              }
            }
            if (stream.required_srt_links !== undefined) {
              for (const processid in stream.required_srt_links) {
                numsrtlinks += 1
                machine.expandeddatasrt[processid] = stream.required_srt_links[processid]
                machine.expandeddatasrt[processid].streamid = streamid
                machine.expandeddatasrt[processid].type = 'required_srt_links'
                machine.expandeddatasrt[processid].status = SystemStatus.ERROR
                machine.expandeddatasrt[processid].statusclass = 'status redstatus'
                machine.expandeddatasrt[processid].linkstr = '' +
                  machine.expandeddatasrt[processid].sink_server + '/' + machine.expandeddatasrt[processid].sink_name + ' -> ' +
                  machine.expandeddatasrt[processid].src_server + '/' + machine.expandeddatasrt[processid].src_name
                machine.expandeddatasrt[processid].processid = processid + machine.expandeddatasrt

                for (const machineid2 in this.transcodingStats) {
                  const transcodingmachine2 = this.transcodingStats[machineid2]
                  if (transcodingmachine2 && 'transcodes' in transcodingmachine2 && processid in transcodingmachine2.transcodes &&
                  'status' in transcodingmachine2.transcodes[processid]) {
                    machine.expandeddatasrt[processid].status = transcodingmachine2.transcodes[processid].status
                    if (machine.expandeddatasrt[processid].status === 'green') {
                      machine.expandeddatasrt[processid].statusclass = 'status greenstatus'
                    }
                  }
                }
              }
            }
          }
        }
        if (machine.srtwowzaservers && machine.srtwowzaservers.length > 0) {
          machine.numsrtlinks = `${numsrtlinks}`
        } else {
          machine.numsrtlinks = numsrtlinks === 0 ? 'N/A' : `N/A${numsrtlinks}`
        }
        machine.numtranscodes = numtranscodes
        machine.allocated = '' + totalAllocated + '/' + machine.total_cpu
        convertedTranscodingMachines.push(machine)
      })
      this.convertedTranscodingMachines = convertedTranscodingMachines
    }
  },
  components: {
    'el-table': Table,
    'el-table-column': TableColumn,
    LeftSidebarLayout
  }
})
